import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ElectronService } from './services/electron.service';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';

import { CommonService } from './services/common.service';
import { GetinfoService } from './services/getinfo.service';

// import * as internalIp from 'internal-ip'

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: 'app.component.html',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {

  myinfo: any;
  logged: boolean = false;

  constructor(
    private router: Router,
    public iconSet: IconSetService,
    public electronService: ElectronService,
    public commonService: CommonService,
    public getinfoService: GetinfoService
  ) {
    // iconSet singleton
    iconSet.icons = { ...freeSet };
  }

  ngOnInit() {

    this.loginCheck();
    
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

   // 내 사설 아이피
  //  let ip = internalIp.internalIpV4Sync();

    if(this.electronService.isElectron) {
      this.startServer();
    }
  }

  async loginCheck() {
    let myinfo = localStorage.getItem('myinfo');

    if(myinfo != '' && myinfo != 'undefined' && myinfo !== undefined && myinfo !== null) {
      this.myinfo = JSON.parse(myinfo);
      this.logged = true;
      // console.log(this.myinfo);
      if(this.myinfo.agree != "1") {
        // await this.getinfoService.refreshToken(this.myinfo.mem_id);
        this.router.navigateByUrl("/agreement");
        return;
      }
    }
    else {
      this.myinfo = {};
      this.logged = false;

      this.router.navigateByUrl("/login");
    }
  }


  startServer() {
    this.electronService.ipcRenderer.send("startServer",{});
    // this.listenRFID();
    this.listenBLE();
  }

  listenBLE() {
    this.electronService.ipcRenderer.on('ble-data' , function(event , data) { 
      
      let rawdata = JSON.parse(data.rawdata.replace(/\r/gi, '\\r').replace(/\n/gi, '\\n').replace(/\t/gi, '\\t').replace(/\f/gi, '\\f'));
      console.log(rawdata);
      // rawdata.forEach((item) => {
      //   if(item.bleName.substr(0,10) == 'sdnpartner') {
      //     let mem_uid = item.bleName.split('_')[1];
      //     console.log(mem_uid);
      //   }
      // });

      // let bleNames = [];
      // rawdata.forEach((item) => {
      //   if(item.bleName !== undefined) {
      //     if(item.bleName.indexOf('MiniBeacon_') > -1) {
      //       if (!bleNames.includes(item.bleName)) {
      //         bleNames.push(item.bleName);
      //       }
      //     }
      //   }
      // });

      // console.log('bleNames');
      // console.log(bleNames);
      // // 출입 체크
      // let currentUsersJSON = localStorage.getItem('currentUsers');
      // let currentUsers = [];
      // if(currentUsersJSON != '' && currentUsersJSON != 'undefined' && currentUsersJSON !== undefined && currentUsersJSON !== null) {
      //   currentUsers = JSON.parse(currentUsersJSON);
      // }

      // let attendances = [];
      // let exits = [];

      // bleNames.forEach((id) => {
      //   if(!currentUsers.includes(id)) {
      //     attendances.push(id);
      //   }
      // });

      // currentUsers.forEach((id) => {
      //   if(!bleNames.includes(id)) {
      //     exits.push(id);
      //   }
      // });

      // if(attendances.length > 0) {
      //   console.log('attendances',attendances);
      // }
      
      // if(exits.length > 0) {
      //   console.log('exits',exits);
      // }

      // localStorage.setItem('currentUsers',JSON.stringify(bleNames));

    });
  }
}
